<template>
  <b-modal
    @close="$emit('close', $event)"
    @hidden="$emit('hidden', $event)"
    :hide-footer="hideFooter"
    :content-class="[
      'divide-y',
      {
        'max-w-full h-full max-h-full rounded-none overflow-x-hidden overflow-y-auto': fullScreen,
      }
    ]"
    :dialog-class="[ fullScreen ? dialogClasses : '']"
    :header-class="{
      'fullscreen': fullScreen,
    }"
    :hideHeaderClose="hideHeaderClose"
    v-bind="$props"
  >
    <template v-slot:modal-header-close>
      <slot name="modal-header-close"></slot>
    </template>
    <template v-slot:modal-title>
      <slot name="modal-title"></slot>
    </template>
    <template v-slot:default>
      <slot></slot>
    </template>
    <template v-slot:modal-footer>
      <slot name="modal-footer">
        <div></div>
      </slot>
    </template>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      dialogClasses: [
        'fullscreen',
        'm-0',
        'h-full',
        'max-w-full',
        'max-h-full',
        'bg-white',
        'overflow-x-hidden',
        'overflow-y-auto',
      ],
    };
  },
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
    hideFooter: {
      type: Boolean,
      required: false,
      default: false,
    },
    noStacking: {
      type: Boolean,
      required: false,
      default: false,
    },
    size: {
      type: String,
      required: false,
    },
    fullScreen: {
      type: Boolean,
      default: false,
    },
    hideHeaderClose: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
<style lang="scss">
  .modal-header {
    &.fullscreen {
      padding-left: 192px;
      .close {
        position: absolute;
        top: 40px;
        left: 40px;
      }
    }
  }
  .modal-body {
    &.fullscreen {
      border-top: none;
    }
  }
</style>
